export function modal() {
  function init() {
    handleClose();
    handleOpen();
  }

  function handleOpen() {
    const modalToggles = document.querySelectorAll("[data-toggle='modal']");

    modalToggles.forEach((modalToggle) => {
      modalToggle.addEventListener("click", (evt) => {
        const currentModal = document.querySelector(
          "#" + evt.currentTarget.dataset.modal
        );

        if (!currentModal) {
          return;
        }

        currentModal.dataset.visible = true;
      });
    });
  }

  function handleClose() {
    const modalCloses = document.querySelectorAll(".modal-close");

    modalCloses.forEach((modalClose) => {
      modalClose.addEventListener("click", (evt) => {
        const currentModal = evt.currentTarget.closest(".modal");

        if (!currentModal) {
          return;
        }

        currentModal.dataset.visible = false;
      });
    });
  }

  return {
    init,
  };
}
